/**
 * Turning a failure into something an admin can read.
 *
 * The internal apis answer with the class name of the exception they raised, and the name is
 * what is matched on: their messages are english developer prose and change without notice,
 * the class names are a contract.
 */

import { t, ru } from "../i18n/strings";
import type { TranslationKey } from "../i18n/strings";
import { ApiError, NotAnAdminError, NotInTelegramError } from "./client";

function getErrorKey(exception: string): TranslationKey | null {
  const key = `error.${exception}` as TranslationKey;
  return key in ru ? key : null;
}

export function describeError(error: unknown): string {
  if (error instanceof NotInTelegramError) {
    return t("app.outside");
  }

  if (error instanceof NotAnAdminError) {
    return t("app.forbidden");
  }

  if (error instanceof ApiError) {
    if (error.exception) {
      const key = getErrorKey(error.exception);
      if (key) {
        return t(key);
      }
    }
    // 502 is adminwebapi saying an internal api did not answer at all, which is a different
    // thing from that api refusing something and is worth its own wording
    if (error.status === 502) {
      return t("error.network");
    }
    return error.message || t("error.backend");
  }

  return t("error.backend");
}
